import { AbstractControl, ValidatorFn } from '@angular/forms';

export const phoneNumberRegexValidator =
  (regex: string): ValidatorFn =>
  (control: AbstractControl): { [key: string]: unknown } | null => {
    const phoneNumberRegex = new RegExp(regex);
    const forbidden = control.value && !phoneNumberRegex.test(control.value);
    return forbidden ? { phoneNumber: { value: control.value } } : null;
  };
